export const getTerminalRequestCode = {
    "curl": {
      "request": `curl -X 'POST'
        'https://demo-api.westpay.se/access/v2/getTerminalId'
        -H 'accept: text/plain'
        -H 'Ocp-Apim-Subscription-Key: <merchant-subscription-key>'
        -H 'Authorization: Bearer <access-token>'
        -H 'Content-Type: application/json'
        -d '{
        "storeId": "<your storeId>",
        "ecrId": "<associated ecrId>"
    }'`
    },
    "java": {
      "request": `
    import com.fasterxml.jackson.databind.ObjectMapper;
    import java.io.IOException;
    import java.net.URI;
    import java.net.http.HttpClient;
    import java.net.http.HttpRequest;
    import java.net.http.HttpResponse;
    import java.net.http.HttpResponse.BodyHandlers;
      
    public class Main {
        public static void main(String[] args) {
            getTerminalIdAsync();
        }
      
        static void getTerminalIdAsync() {
            String apiUrl = "https://demo-api.westpay.se/access/v2/getTerminalId";
            String merchantSubscriptionKey = "<merchant-subscription-key>";
            String accessToken = "<access-token>";
      
            RequestData requestData = new RequestData("<your storeId>", "<associated ecrId>");
      
            HttpClient httpClient = HttpClient.newBuilder().build();
      
            try {
                ObjectMapper objectMapper = new ObjectMapper();
                String requestBody = objectMapper.writeValueAsString(requestData);
      
                HttpRequest request = HttpRequest.newBuilder()
                        .uri(URI.create(apiUrl))
                        .header("accept", "text/plain")
                        .header("Ocp-Apim-Subscription-Key", merchantSubscriptionKey)
                        .header("Authorization", "Bearer " + accessToken)
                        .header("Content-Type", "application/json")
                        .POST(HttpRequest.BodyPublishers.ofString(requestBody))
                        .build();
      
                HttpResponse<String> response = httpClient.send(request, BodyHandlers.ofString());
      
                if (response.statusCode() == 200) {
                    String responseBody = response.body();
                    System.out.println("API response: " + responseBody);
                } else {
                    System.out.println("API request failed. Status code: " + response.statusCode());
                }
            } catch (IOException | InterruptedException e) {
                System.out.println("An error occurred while making the API request: " + e.getMessage());
            }
        }
      
        static class RequestData {
            private String storeId;
            private String ecrId;
      
            public RequestData(String storeId, String ecrId) {
                this.storeId = storeId;
                this.ecrId = ecrId;
            }
      
            // Add getters and setters if needed
        }
    }`
    },
    "C#": {
      "request": `
    using System;
    using System.Net.Http;
    using System.Threading.Tasks;
      
    class Program
    {
        static async Task Main(string[] args)
        {
            await GetTerminalIdAsync();
        }
      
        static async Task GetTerminalIdAsync()
        {
            string apiUrl = "https://demo-api.westpay.se/access/v2/getTerminalId";
            string merchantSubscriptionKey = "<merchant-subscription-key>";
            string accessToken = "<access-token>";
      
            var requestData = new
            {
                storeId = "<your storeId>",
                ecrId = "<associated ecrId>"
            };
      
            using (var httpClient = new HttpClient())
            {
                httpClient.DefaultRequestHeaders.Add("accept", "text/plain");
                httpClient.DefaultRequestHeaders.Add("Ocp-Apim-Subscription-Key", merchantSubscriptionKey);
                httpClient.DefaultRequestHeaders.Add("Authorization", $"Bearer {accessToken}");
                httpClient.DefaultRequestHeaders.Add("Content-Type", "application/json");
      
                try
                {
                    var response = await httpClient.PostAsJsonAsync(apiUrl, requestData);
      
                    if (response.IsSuccessStatusCode)
                    {
                        var responseContent = await response.Content.ReadAsStringAsync();
                        Console.WriteLine("API response: " + responseContent);
                    }
                    else
                    {
                        Console.WriteLine("API request failed. Status code: " + response.StatusCode);
                    }
                }
                catch (HttpRequestException ex)
                {
                    Console.WriteLine("An error occurred while making the API request: " + ex.Message);
                }
            }
        }
    }`
    },
    "python": {
      "request": `
    import requests
    def get_terminal_id():
        api_url = 'https://demo-api.westpay.se/access/v2/getTerminalId'
        merchant_subscription_key = '<merchant-subscription-key>'
        access_token = '<access-token>'
      
        request_data = {
            'storeId': '<your storeId>',
            'ecrId': '<associated ecrId>'
        }
      
        headers = {
            'accept': 'text/plain',
            'Ocp-Apim-Subscription-Key': merchant_subscription_key,
            'Authorization': f'Bearer {access_token}',
            'Content-Type': 'application/json'
        }
      
        try:
            response = requests.post(api_url, json=request_data, headers=headers)
      
            if response.status_code == 200:
                print('API response:', response.text)
            else:
                print('API request failed. Status code:', response.status_code)
        except requests.RequestException as e:
            print('An error occurred while making the API request:', e)
      
    get_terminal_id()`
    },
    
    "JavaScript": {
      "request": `const axios = require('axios');

    async function getTerminalIdAsync() {
      const apiUrl = 'https://demo-api.westpay.se/access/v2/getTerminalId';
      const merchantSubscriptionKey = '<merchant-subscription-key>';
      const accessToken = '<access-token>';
      
      const requestData = {
        storeId: '<your storeId>',
        ecrId: '<associated ecrId>',
      };
      
      const headers = {
        accept: 'text/plain',
        'Ocp-Apim-Subscription-Key': merchantSubscriptionKey,
         Authorization: 'Bearer '+ accessToken,
        'Content-Type': 'application/json',
      };
      
      try {
        const response = await axios.post(apiUrl, requestData, { headers });
      
        if (response.status === 200) {
          console.log('API response:', response.data);
        } else {
          console.log('API request failed. Status code:', response.status);
        }
      } catch (error) {
        console.log('An error occurred while making the API request:', error.message);
      }
    }
      
    getTerminalIdAsync()`
    }
  };
  
export const getTerminalRequestCodeResponse = `
    {
        "terminalId": "<allocated terminalId>",
        "password": "<password>"
    }`;

  